import { InputRuleApiModel } from '~/lib/api/smartsend/types';

export function GetDefaultRules(countryIso: string): InputRuleApiModel[] {
  return [
    {
      value: '',
      name: 'Name',
      label: 'Contact Name',
      inputMode: 'text',
      type: 'text',
      required: true,
      helperText: 'Contact Name',
      maxLength: 50,
      minLength: undefined
    },
    {
      value: '',
      name: 'Organisation',
      label: 'Organisation',
      inputMode: 'text',
      type: 'text',
      required: false,
      maxLength: 50,
      minLength: undefined
    },
    {
      value: '',
      name: 'AddressLine1',
      label: 'House Number',
      inputMode: 'text',
      type: 'text',
      required: true,
      helperText: 'Building Number or Name',
      maxLength: 50
    },
    {
      value: '',
      name: 'AddressLine2',
      label: 'Street',
      inputMode: 'text',
      type: 'text',
      required: true,
      helperText: 'Street',
      maxLength: 50
    },
    {
      value: '',
      name: 'Town',
      label: 'Town',
      inputMode: 'text',
      type: 'text',
      required: true,
      helperText: 'Town',
      maxLength: 50
    },
    {
      value: '',
      name: 'Locality',
      label: 'Locality',
      inputMode: 'text',
      type: 'text',
      required: false,
      helperText: 'Locality',
      maxLength: 50
    },
    {
      value: '',
      name: 'County',
      label: 'County',
      inputMode: 'text',
      type: 'text',
      required: true,
      helperText: 'County or State',
      maxLength: 50
    },
    {
      value: '',
      name: 'CountryIsoCode',
      label: 'Country',
      inputMode: 'text',
      type: 'text',
      required: true
    },
    {
      value: '',
      name: 'CountrySubdivision',
      label: 'Country Subdivision',
      inputMode: 'text',
      type: 'text',
      required: false
    },
    {
      value: '',
      name: 'Postcode',
      label: 'Postcode',
      inputMode: 'text',
      type: 'text',
      required: true,
      helperText: 'Postcode',
      maxLength: 16,
      pattern: countryIso === 'GBR' ? '^[a-zA-Z]{1,2}[0-9][0-9a-zA-Z]? ?[0-9][a-zA-Z]{2}$' : undefined
    },
    {
      value: '',
      name: 'Phone',
      label: 'Phone Number',
      inputMode: 'tel',
      type: 'tel',
      required: true,
      helperText: 'Phone Number',
      maxLength: 24,
      minLength: 8
    },
    {
      value: '',
      name: 'Email',
      label: 'Email',
      inputMode: 'email',
      type: 'email',
      required: true,
      helperText: 'Email address',
      maxLength: 256,
      pattern: "[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)+"
    }
  ];
}
